export const CALLBOT_CRM_URL = process.env.REACT_APP_CALLBOT_CRM_URL;

export const IAM_URL = process.env.REACT_APP_IAM_URL;
export const IAM_REALM = process.env.REACT_APP_IAM_REALM;
export const IAM_CLIENT_ID = process.env.REACT_APP_IAM_CLIENT_ID;
export const CALLBOT_ACCOUNT_URL = process.env.REACT_APP_CALLBOT_ACCOUNT_URL;
